/**
 * Re-measure a Vuetify tooltip after it opens, then slide the arrow onto the activator.
 * The first measurement often runs before the bubble has a real width, which leaves
 * the arrow beside the avatar instead of on it.
 */
export function repositionVTooltip(tooltip) {
  if (!tooltip || typeof tooltip.updateDimensions !== 'function') return;

  tooltip.$nextTick(() => {
    tooltip.updateDimensions();
    requestAnimationFrame(() => {
      tooltip.updateDimensions();
      requestAnimationFrame(() => alignTooltipArrow(tooltip));
    });
  });
}

function alignTooltipArrow(tooltip) {
  const content = tooltip.$refs && tooltip.$refs.content;
  const activator = typeof tooltip.getActivator === 'function' ? tooltip.getActivator() : null;
  if (!content || !activator || typeof content.getBoundingClientRect !== 'function') return;

  const contentRect = content.getBoundingClientRect();
  const activatorRect = activator.getBoundingClientRect();
  if (!contentRect.width || !activatorRect.width) return;

  const delta = (activatorRect.left + activatorRect.width / 2)
    - (contentRect.left + contentRect.width / 2);
  content.style.setProperty('--tooltip-arrow-shift', `${Math.round(delta)}px`);
}
